export default __webpack_public_path__ + "static/media/icons-check.7168ce8e.svg";